import React from "react";
import { useLocalizedStrings } from "../Localization";

const Skills = () => {
  const strings = useLocalizedStrings(); // Lokalizasyon dosyasından verileri alıyoruz

  const skills = [
    { name: strings.python, icon: "🐍", description: strings.pythonDesc },
    { name: strings.cpp, icon: "📦", description: strings.cppDesc },
    { name: strings.bashScript, icon: "💻", description: strings.bashScriptDesc },
    { name: strings.sql, icon: "🗄️", description: strings.sqlDesc },
    { name: strings.firebase, icon: "🔥", description: strings.firebaseDesc },
    { name: strings.react, icon: "⚛️", description: strings.reactDesc },
    { name: strings.tailwind, icon: "🎨", description: strings.tailwindDesc },
    { name: strings.js, icon: "📜", description: strings.jsDesc },
    { name: strings.tensorflow, icon: "🧠", description: strings.tensorflowDesc },
    { name: strings.pytorch, icon: "🔥", description: strings.pytorchDesc },
    { name: strings.opencv, icon: "📷", description: strings.opencvDesc },
    { name: strings.pandas, icon: "📊", description: strings.pandasDesc },
    { name: strings.numpy, icon: "🔢", description: strings.numpyDesc },
    { name: strings.fastapi, icon: "⚡", description: strings.fastapiDesc },
    { name: strings.flask, icon: "🍶", description: strings.flaskDesc },
    { name: strings.scikit, icon: "📈", description: strings.scikitDesc },
    { name: strings.git, icon: "🔧", description: strings.gitDesc },
    { name: strings.docker, icon: "🐳", description: strings.dockerDesc },
    { name: strings.kubernetes, icon: "☸️", description: strings.kubernetesDesc },
    { name: strings.linux, icon: "🐧", description: strings.linuxDesc },
    { name: strings.hadoop, icon: "🐘", description: strings.hadoopDesc },
    { name: strings.hive, icon: "🏠", description: strings.hiveDesc },
    { name: strings.sqoop, icon: "🔄", description: strings.sqoopDesc },
    { name: strings.kafka, icon: "📡", description: strings.kafkaDesc },
    { name: strings.sqlserver, icon: "💾", description: strings.sqlserverDesc },
    { name: strings.unreal, icon: "🎮", description: strings.unrealDesc },
    { name: strings.gazebo, icon: "🤖", description: strings.gazeboDesc },
    { name: strings.missionPlanner, icon: "✈️", description: strings.missionPlannerDesc }
  ];

  return (
    <div className="relative flex justify-center md:p-10 p-2 bg-[#FFDCCC] border-4 border-black rounded-xl shadow-lg m-auto md:w-[80%] w-[90%]">
      <div 
        id="skills" 
        className="absolute -top-14 left-5 bg-black text-white px-4 py-2 text-4xl rounded-t-lg"
        style={{ fontFamily: 'Bokor' }}
      >
        {strings.mySkills}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-6 w-full px-6">
        {skills.map((skill, index) => (
          <div
            key={index}
            className="border-4 border-black p-6 rounded-xl shadow-lg flex flex-col items-center justify-center text-center bg-white w-full max-w-[160px] h-40"
          >
            <span className="text-3xl">{skill.icon}</span>
            <h3 className="font-bold mt-2">{skill.name}</h3>
            <p className="text-sm text-gray-600">{skill.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
